import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

interface NameProps {
  children: string
  isClickable: boolean
  shouldWrap?: boolean
  hasInvertedColors: boolean
}

const StyledName = styled.span<NameProps>`
  ${({
    theme: {
      colors: { textDefault, staticWhite },
      typography: {
        subheads: {
          small1: { bundledCSS: small1SubheadsCSS },
        },
      },
    },
    isClickable,
    shouldWrap,
    hasInvertedColors,
  }) => css`
    ${small1SubheadsCSS};

    ${!shouldWrap &&
    css`
      white-space: nowrap;
    `}

    ${isClickable &&
    css`
      color: ${hasInvertedColors ? staticWhite : textDefault};
      text-decoration: underline;
    `}
  `}
`

const Name: FunctionComponent<NameProps> = ({
  children,
  isClickable,
  shouldWrap,
  hasInvertedColors,
}) => (
  <StyledName
    isClickable={isClickable}
    shouldWrap={shouldWrap}
    hasInvertedColors={hasInvertedColors}
  >
    {children}
  </StyledName>
)

export default Name
